import React from "react";
import CS from "../../assets/CS 1.webp";
import real_time_accuracy from "../../assets/CS 2.webp";
import CS3 from "../../assets/CS 3.webp";
import frame from "../../assets/CS 4.webp";
import CS5 from "../../assets/CS 5.webp";
import cardImage1 from "../../assets/delivery.png";
import cardImage2 from "../../assets/timer.png";
import cardImage3 from "../../assets/tracking.png";
import cardImage4 from "../../assets/CS8.png";
import "../../Css/FiveCard.css";

const CodeStrength = () => {
  return (
   <section className="bg-white py-8 sm:py-10 lg:py-12">
  <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-4">
    <h2 className="mb-6 text-center text-[24px] font-bold sm:text-[28px] md:text-[28px] text-[#212529] font-sf">
      Core Strengths
    </h2>

    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3">
      {/* Card 1 */}
      <div
        className="card rounded-[8px] border-0 h-[260px] sm:h-[290px] lg:h-[310px]"
        style={{
          background: "linear-gradient(135deg, #F5FBFD, #D3EEFB)",
        }}
      >
        <div className="card-body flex h-full flex-col p-4 sm:p-5">
          <h3 className="card-title mt-4 !text-[18px] !md:text-[22px]leading-6 !font-bold !text-[#212529] font-sf sm:!text-[20px]">
            Tailored for <br /> Businesses
          </h3>

          <div className="mt-auto flex items-end justify-center">
            <img
              src={CS}
              alt="Tailored for Restaurants"
              className="h-auto max-w-full rounded object-contain max-h-[190px] sm:max-h-[180px] lg:max-h-[200px]"
            />
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div
        className="card rounded-[8px] border-0 h-[260px] sm:h-[290px] lg:h-[310px]"
        style={{
          background: "linear-gradient(135deg, #FFF7ED, #FDE9D1)",
        }}
      >
        <div className="card-body flex h-full flex-col p-4 sm:p-5">
          <h3 className="card-title mt-4 !text-[18px] leading-6 !font-bold !text-[#212529] font-sf sm:!text-[20px]">
            Real-Time <br /> Accuracy
          </h3>

          <div className="mt-auto flex justify-center">
            <img
              src={real_time_accuracy}
              alt="Real-Time Accuracy"
              className="h-auto max-w-full rounded object-contain max-h-[190px] sm:max-h-[180px] lg:max-h-[200px]"
            />
          </div>
        </div>
      </div>

      {/* Card 3 */}
      <div
        className="card rounded-[8px] border-0 h-[260px] sm:h-[290px] lg:h-[310px]"
        style={{
          background: "linear-gradient(135deg, #E8FADD, #DCFFC6)",
        }}
      >
        <div className="card-body flex h-full flex-col p-4 sm:p-5">
          <h3 className="card-title mt-4 !text-[18px] leading-6 !font-bold !text-[#212529] font-sf sm:!text-[20px]">
            Enhanced Delivery <br /> Experience
          </h3>

          <div className="mt-auto flex justify-center">
            <img
              src={CS3}
              alt="Enhanced Customer Experience"
              className="h-auto max-w-full rounded object-contain max-h-[190px] sm:max-h-[180px] lg:max-h-[200px]"
            />
          </div>
        </div>
      </div>

      {/* Card 4 */}
      <div
        className="card rounded-[8px] border-0 h-[260px] overflow-hidden sm:h-[290px] lg:h-[310px]"
        style={{
          background: "linear-gradient(135deg, #FFF3ED, #FDDECF)",
        }}
      >
        <div className="card-body flex h-full flex-col p-4 sm:p-5">
          <h3 className="card-title mt-4 mb-3 !text-[18px] leading-6 !font-bold !text-[#212529] font-sf sm:!text-[20px]">
            Cost Efficiency
          </h3>

          <div className="mt-auto flex flex-1 items-center justify-center pb-4 xl:-mt-16">
            <img
              src={frame}
              alt="Cost Efficiency"
              className="h-auto max-w-full object-contain max-h-[220px] sm:max-h-[170px] md:max-h-[240px] lg:max-h-[280px] xl:max-h-[360px]"
            />
          </div>
        </div>
      </div>

      {/* Large Card */}
    <div className="rounded-[8px] bg-[#E7D9FF] h-[260px] sm:h-[290px] lg:h-[310px] sm:col-span-2 lg:col-span-2">
  <div className="relative h-[260px] sm:h-[290px] lg:h-[310px] overflow-visible">

    <h3 className=" sm:mb-6 lg:mb-8 text-[18px] mt-4 ml-4 sm:text-[20px] font-bold leading-[1.2] text-[#212529] font-sf">
      Real-Time Delivery <br /> Tracking
    </h3>

    {/* MAIN ROW: always side by side at all breakpoints */}
    <div className="flex flex-row items-center justify-between">

      {/* LEFT: 2×2 grid on mobile, single row on sm+ */}
      <div className="
        grid grid-cols-2 ml-4 mb-2 lg:mb-56 md:mb-40 sm:mb-36 gap-2
        sm:flex sm:flex-row sm:flex-nowrap sm:gap-3
        shrink-0
      ">
        {[cardImage3, cardImage1, cardImage2, cardImage4].map((img, index) => {
          const texts = [
            ["Easy", "Returns"],
            ["Live-Order", "Tracking"],
            ["Scheduled", "Deliveries"],
            ["Contactless", "Delivery"],
          ];

          return (
            <div
              key={index}
              className="
                flex flex-col items-center justify-center
                rounded-[7px] bg-white p-1.5 sm:p-2
                w-[62px] h-[62px]
                sm:w-[76px] sm:h-[76px]
                lg:w-[82px] lg:h-[82px]
                shrink-0
              "
            >
              <img
                src={img}
                alt={texts[index].join(" ")}
                className="mb-1 h-5 w-5 sm:h-6 sm:w-6 lg:h-7 lg:w-7 object-contain"
              />
              <p className="text-center text-[8px] sm:text-[9px] lg:text-[10px] font-medium leading-[1.15] text-[#212529] font-sf">
                {texts[index][0]} <br />
                {texts[index][1]}
              </p>
            </div>
          );
        })}
      </div>

      {/* RIGHT: image always on the right, bottom-anchored */}
      <div className="absolute bottom-4 right-0 flex justify-end">
        <img
          src={CS5}
          alt="Delivery tracking illustration"
          className="
            object-contain object-right
            w-[140px] max-h-[160px]
            sm:w-[240px] sm:max-h-[240px]
            md:w-[220px] md:max-h-[200px]
            lg:w-[240px] lg:max-h-[190px]
            xl:w-[320px] xl:max-h-[290px]
          "
        />
      </div>

    </div>
  </div>
</div>
    </div>
  </div>
</section>
  );
};

export default CodeStrength;